/**
 * Helper function for simple page strategies
 * Applies dynamic defaults to static page SEO content
 *
 * @deprecated Use applySimplePageSeo from seo-strategy.helpers.ts instead
 * This function is kept for backward compatibility
 */

import { CachedContent } from '../../../../interfaces/cached-content';
import { Seo } from '../../../../interfaces/seo';
import { applySimplePageSeo } from './seo-strategy.helpers';
import { SeoStrategyFn } from './seo-strategy.type';

/**
 * Generic strategy for simple pages (FAQ, Help, Installation, etc.)
 * @param seoKey - The key in the SEO JSON (e.g., 'faq', 'help')
 * @param pageName - The page name for image generation (e.g., 'faq', 'help')
 * @param currentPath - The current route path (e.g., '/faq', '/contact-us')
 * @returns A type-safe strategy function that applies SEO to the document
 */
export function createSimplePageStrategy(
  seoKey: string,
  pageName: string,
  currentPath: string
): SeoStrategyFn {
  return function (seoContent: Seo, $document: Document, cacheContent: CachedContent): void {
    applySimplePageSeo(seoKey, pageName, currentPath, seoContent, $document, cacheContent);
  };
}
